import * as React from 'react';
import { checkValue } from 'src/components/functions';
import videojs from 'video.js';
import 'videojs-youtube';
import '@devmobiliza/videojs-vimeo/dist/videojs-vimeo.esm.js';
import gaLogger from 'src/utils/ga-logger';
import { onImageLoadWithoutCache } from '../../helper';

interface VideoPlayerPropsInferface {
  videoJsOptions: videojs.PlayerOptions;
  isBackground: boolean;
}

const players = [];

export default class VideoPlayer extends React.Component<any, any> {
  private player?: videojs.Player;
  private videoNode?: HTMLVideoElement;

  constructor(props: VideoPlayerPropsInferface) {
    super(props);
    this.player = undefined;
    this.videoNode = undefined;
  }

  componentDidMount() {
    const { selector, backgroundImg, hoverImage } = this.props;

    let videoURL = '';
    if (checkValue(this.props.videoOptions.sources, true)) {
      videoURL = this.props.videoOptions.sources[0].src;
    }

    this.player = videojs(this.videoNode, this.props.videoOptions, function onPlayerReady() {
      const posterElement: HTMLElement = document.querySelector(selector);
      if (checkValue(backgroundImg)) {
        if (posterElement !== null) {
          const imgPoster = document.createElement('img');
          imgPoster.src = backgroundImg;
          imgPoster.style.width = '100%';
          imgPoster.style.height = '100%';
          imgPoster.className = 'image-poster';
          posterElement.appendChild(imgPoster);
        }
      }
      if (checkValue(hoverImage)) {
        if (posterElement !== null) {
          const imgHover = document.createElement('img');
          imgHover.src = hoverImage;
          imgHover.style.width = '100%';
          imgHover.style.height = '100%';
          imgHover.className = 'image-hover';
          posterElement.appendChild(imgHover);
        }
      }
    });

    let timeCount = 0;

    this.player.on('play', () => {
      if (!this.player.seeking()) {
        gaLogger.logGa('video play', 'started playing', videoURL);
      }
    });

    this.player.on('pause', () => {
      if (!this.player.seeking() && !this.player.ended()) {
        gaLogger.logGa('video play', 'paused playing', videoURL, this.player.currentTime());
      }
    });

    this.player.on('ended', () => {
      gaLogger.logGa('video play', 'playing ended', videoURL);
    });

    this.player.on('seeked', () => {
      timeCount = 0;
      gaLogger.logGa('video play', 'adjusted timeline', videoURL, this.player.currentTime());
    });

    this.player.on('timeupdate', () => {
      const playedPercentage = parseInt(((this.player.currentTime() / this.player.duration()) * 100).toString());
      const percentageStep = playedPercentage % 5;
      if (percentageStep == 0 && playedPercentage > timeCount) {
        timeCount = playedPercentage;
        gaLogger.logGa('video play', 'played percentage', videoURL, playedPercentage);
      }
    });

    this.player.bigPlayButton.on('click', function() {
      if (checkValue(videoURL)) {
        gaLogger.logGa('video play', 'play clicked', videoURL);
      }
    });

    if (checkValue(selector)) {
      if (checkValue(hoverImage)) {
        this.player.bigPlayButton.on('mousemove', function() {
          const posterElement: HTMLImageElement = document.querySelector(selector + ' .image-poster');
          if (posterElement !== null) {
            posterElement.style.opacity = '0';
          }
        });
      }
      if (checkValue(backgroundImg)) {
        this.player.bigPlayButton.on('mouseleave', function() {
          const posterElement: HTMLImageElement = document.querySelector(selector + ' .image-poster');
          if (posterElement !== null) {
            posterElement.style.opacity = '1';
          }
        });
      }
    }

    window.addEventListener('resize', () => {
      // check the player information already added or not
      players.forEach(item => {
        const el: any = document.getElementById(item.id);
        const mainEl: any = document.querySelector('.t-video-container');
        const childEl: any = document.querySelector('.t-video-container ' + '#' + item.id);

        if (childEl !== null) {
          // set the video ratio to hero player container
          mainEl.style.paddingBottom = '0px';
          mainEl.style.height = (item.height / item.width) * el.offsetWidth + 'px';
        } else {
          // set the video ratio to player
          el.style.paddingBottom = '0px';
          el.style.height = (item.height / item.width) * el.offsetWidth + 'px';
        }
      });
    });

    // player resize
    this.videoPlayerSetting();
  }

  private videoPlayerSetting = () => {
    videojs(this.videoNode, {}, function() {
      this.on('play', function() {
        const ratio = { width: this.videoWidth() || 1920, height: this.videoHeight() || 860, id: this.id_ };
        let isInclude = false;
        const el: any = document.getElementById(ratio.id);
        const mainEl: any = document.querySelector('.t-video-container');
        const childEl: any = document.querySelector('.t-video-container ' + '#' + ratio.id);

        // check the player information already added or not
        players.forEach(item => {
          if (item.id == ratio.id) {
            isInclude = true;
          }
        });

        // add player information to array
        if (!isInclude) {
          players.push(ratio);
        }

        if (childEl !== null) {
          // set the video ratio to player
          mainEl.style.paddingBottom = '0px';
          mainEl.style.height = (ratio.height / ratio.width) * el.offsetWidth + 'px';
        } else {
          el.style.paddingBottom = '0px';
          el.style.height = (ratio.height / ratio.width) * el.offsetWidth + 'px';
        }
      });
    });
  };

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  render() {
    return (
      <div className={`c-player ${this.props.isBackground ? 'vid-banner' : ''}`}>
        <video ref={node => (this.videoNode = node)} className="video-js vjs-default-skin article-video" />
        {this.props.copyrightText && this.props.copyrightText.length > 0 && (
          <div className="image-copyrights">
            <img
              className="camera-icon"
              src={onImageLoadWithoutCache("https://mesocp3.azureedge.net/media/8d7fca0c8c2035d/icon-camera.svg")}
              alt=""
            />
            <span>{this.props.copyrightText}</span>
          </div>
        )}
      </div>
    );
  }
}
